/*
 * Le panneau Notifications des Paramètres du téléphone (chantier notifications-socle, ticket 03) :
 * s'abonner, l'essai, les réglages du compte ; une sorte par interrupteur et l'heure des rappels du
 * jour (chantier notifications-sortes, ticket 04). La phrase « Pas de réseau » est celle de Maintenant
 * (`PAS_DE_RESEAU`, `mots/maintenant.ts`).
 */
export const NOTIFICATIONS = 'Notifications';
export const RECEVOIR_SUR_CE_TELEPHONE = 'Recevoir les notifications sur ce téléphone';
export const ENVOYER_UN_ESSAI = 'Envoyer une notification d’essai';
export const ESSAI_EN_ROUTE = 'Envoi…';
export const ESSAI_PARTI = 'Partie : elle arrive dans quelques secondes.';
export const ESSAI_PERDU = 'Ce téléphone n’était plus abonné. Rallume l’interrupteur.';
export const ESSAI_ECHEC = 'Elle n’est pas partie. Réessaie dans un moment.';
export const ABONNEMENT_PAS_FAIT = 'L’abonnement ne s’est pas fait. Réessaie dans un moment.';
export const NOTIFICATIONS_REFUSEES =
  'Les notifications sont refusées pour Nextilt sur ce téléphone. Pour les rendre : les réglages du navigateur, Notifications, Nextilt.';
export const NOTIFICATIONS_IMPOSSIBLES = 'Ajoute Nextilt à l’écran d’accueil depuis Safari, puis rouvre-le d’ici';
export const POUR_TOUS_TES_APPAREILS = 'Pour tous tes appareils';
export const UN_RENDEZ_VOUS_1H_AVANT = 'Un rendez-vous, 1 h avant';
export const LA_FIN_D_UN_RENDEZ_VOUS = 'La fin d’un rendez-vous';
export const UNE_ECHEANCE_PROCHE = 'Une échéance proche';
export const UNE_ATTENTE_QUI_DURE_TROP = 'Une attente qui dure trop';
export const LES_RAPPELS_DU_JOUR_A = 'Les rappels du jour à';
export const RAPPELS_HORS_DE_LA_NUIT = 'Pour l’échéance et l’attente. Les heures de la nuit ne sont pas proposées.';
export const laNuitLaisseLesRappels = (heure: string) => `Les rappels du jour, à ${heure}, restent hors de la nuit.`;
export const LA_NUIT = 'La nuit';
export const REGLAGE_PAS_ENREGISTRE = 'Pas enregistré. Réessaie dans un moment.';
export const RIEN_NE_PART_LA_NUIT = 'Rien ne part pendant la nuit.';
export const LA_NUIT_COMMENCE = 'Commence à';
export const LA_NUIT_FINIT = 'Finit à';
export const nuitEnMots = (debut: string, fin: string) => `De ${debut} à ${fin}`;
